import React, { useState } from "react";

import { Chip } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { UpsellModal } from "@app/analytics/components/UpsellModal";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import { TOOLTIPS } from "@app/common/content";

import TooltipWrapper from "@rui/TooltipWrapper";

const NotAvailableChip = styled(Chip)(({ theme }) => ({
  width: "fit-content",
  height: "20px",
  fontSize: "12px",
  lineHeight: "16px",
  "& .MuiChip-label": {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  borderRadius: "4px",
  textOverflow: "initial",
  color: theme.palette.shades.neutral[500],
}));

const MetricLockChip = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { currentPlan, isEligibleForLegacyPricing } = useBillingContext();

  const shouldUpsell = currentPlan.type !== "enterprise";
  const handleClick = () => setModalOpen(true);

  return (
    <>
      {shouldUpsell && (
        <UpsellModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          currentPlan={currentPlan.type}
          useLegacyPrices={isEligibleForLegacyPricing}
        />
      )}
      <TooltipWrapper
        arrow
        placement="bottom-start"
        title={TOOLTIPS.meetingReport.lockedMetric.recordingDisabled}
      >
        <NotAvailableChip
          label="Not available"
          onClick={shouldUpsell ? handleClick : undefined}
        />
      </TooltipWrapper>
    </>
  );
};

export default MetricLockChip;
